module.exports = __webpack_public_path__ + "img/SLS-alt.243a3a30.svg";